import Image from 'next/image'
import { getCloudinaryImageUrl } from '../../../../utils'

const Module5 = (props: any) => {
  // Common text styles adjusted for Desktop
  const textMainBaseStyle = 'font-extrabold mb-0 leading-[0.9em] tracking-[-0.05em] text-[50px] uppercase mt-[3px]'
  const textSmallBaseStyle = 'font-normal font-swinton mb-0 leading-[1em] tracking-[-0.05em] text-[19px]' // Adjusted weight to normal

  return (
    <div className='font-abcd bg-white py-[100px] px-5'>
      <div className='snap-start snap-section-start theme-black hide-floating-logos relative top-[10px]' />
      <div className='grid grid-cols-2 gap-4'>
        {/* Column 1 */}
        <div className='flex flex-col space-y-0'>
          {/* Text Block 1 */}
          <div className='text-left'>
            <p className={`${textMainBaseStyle}`}>{props.block5Heading1}</p> {/* Increased font size */}
            <p className={`${textSmallBaseStyle} `}>{props.block5Heading1Brief}</p> {/* Adjusted top margin */}
          </div>
          {/* Image 2 */}
          <div className='w-full aspect-[16/7] relative mt-0'>
            {props?.block5Image2?.data?.attributes?.url && (
              <Image
                src={getCloudinaryImageUrl(props?.block5Image2.data.attributes.url, 'q_auto,dpr_auto,f_auto,w_1864')}
                alt={props.block5Heading1}
                layout='fill'
                objectFit='cover'
              />
            )}
          </div>
        </div>
        {/* Column 2 */}
        <div className='flex flex-col space-y-0'>
          {/* Image 1 */}
          <div className='w-full h-full relative'>
            {props?.block5Image1?.data?.attributes?.url && (
              <Image
                src={getCloudinaryImageUrl(props?.block5Image1?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto')}
                alt={props.block5Heading2}
                layout='fill'
                objectFit='cover'
              />
            )}
          </div>
          {/* Text Block 2 */}
          <div className='text-left !-mt-2 -ms-[3px]'>
            <p className={`${textMainBaseStyle}`}>{props.block5Heading2}</p> {/* Increased font size */}
            <p className={`${textSmallBaseStyle} `}>{props.block5Heading2Brief}</p> {/* Adjusted top margin */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Module5
